import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import Root from "./Root";
import { generateToken } from "./firebase";
import { Toaster } from "react-hot-toast";
// import AppRouter from "./routing/AppRouter";

function App() {
  useEffect(() => {
    generateToken();
  }, []);

  return (
    <Provider store={store}>
      <Root />
      <Toaster />
    </Provider>
  );
}

export default App;
